export default __webpack_public_path__ + "static/media/bulk-promo-details-sample.d01039ac.csv";